
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useAuthContext } from '../../context/AuthContext';
import { API } from '../../utils/api';

export function MobPayProfile({ user, headers }) {
  const { logout } = useAuthContext();
  const nav = useNavigate();
  const [showPasswordChange, setShowPasswordChange] = useState(false);
  const [passwordForm, setPasswordForm] = useState({ current_password: '', new_password: '', confirm_password: '' });
  
  const changePassword = async () => {
    if (passwordForm.new_password !== passwordForm.confirm_password) {
      toast.error('New passwords do not match');
      return;
    }
    
    if (passwordForm.new_password.length < 6) {
      toast.error('Password must be at least 6 characters');
      return;
    }
    
    try {
      await axios.post(`${API}/auth/change-password`, {
        current_password: passwordForm.current_password,
        new_password: passwordForm.new_password
      }, { headers });
      
      toast.success('Password changed successfully');
      setShowPasswordChange(false);
      setPasswordForm({ current_password: '', new_password: '', confirm_password: '' });
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Failed to change password');
    }
  };
  
  const handleLogout = async () => {
    await logout();
    nav('/');
  };
  
  return (
    <div className="space-y-6" data-testid="mobpay-profile">
      <h2 className="text-xl font-semibold">Profile</h2>
      <Card>
        <CardHeader>
          <CardTitle>Account Information</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <div>
            <Label>Full Name</Label>
            <Input value={user.full_name} disabled />
          </div>
          <div>
            <Label>Email</Label>
            <Input value={user.email} disabled />
          </div>
          <div>
            <Label>Phone</Label>
            <Input value={user.phone || 'N/A'} disabled />
          </div>
          <div>
            <Label>Nickname</Label>
            <Input value={user.nickname || 'N/A'} disabled />
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader>
          <CardTitle>Security</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          {!showPasswordChange ? (
            <Button onClick={() => setShowPasswordChange(true)}>Change Password</Button>
          ) : (
            <>
              <div>
                <Label>Current Password</Label>
                <Input 
                  type="password"
                  value={passwordForm.current_password}
                  onChange={(e) => setPasswordForm({...passwordForm, current_password: e.target.value})}
                />
              </div>
              <div>
                <Label>New Password</Label>
                <Input 
                  type="password"
                  value={passwordForm.new_password}
                  onChange={(e) => setPasswordForm({...passwordForm, new_password: e.target.value})}
                />
              </div>
              <div>
                <Label>Confirm New Password</Label>
                <Input 
                  type="password"
                  value={passwordForm.confirm_password}
                  onChange={(e) => setPasswordForm({...passwordForm, confirm_password: e.target.value})}
                />
              </div>
              <div className="flex gap-2">
                <Button onClick={changePassword}>Update Password</Button>
                <Button variant="secondary" onClick={() => {
                  setShowPasswordChange(false);
                  setPasswordForm({ current_password: '', new_password: '', confirm_password: '' });
                }}>Cancel</Button>
              </div>
            </>
          )}
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader>
          <CardTitle>Account Actions</CardTitle>
        </CardHeader>
        <CardContent>
          <Button 
            data-testid="logout-button" 
            variant="destructive" 
            onClick={handleLogout}
            className="w-full"
          >
            Logout
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
